<ng-container *ngIf="referralPayoutsView">
  <div class="с-pql-field-new--typed-new">
    <ng-container *ngFor="let item of referralPayoutsView; last as last; index as i">
      <div *ngIf="item" class="с-pql-field-new--typed-new с-pql-field-new--typed-new_bordered">
        <div class="с-pql-field-new__type с-pql-field-new -green">
          <span i18n="@@common.model">Model</span> {{ referralPayoutsView.length > 1 ? i + 1 : '' }}
        </div>
        <div class="с-pql-field-new__type с-pql-field-new">
          {{ item.model }}
        </div>
        <div class="с-pql-field-new__type с-pql-field-new -green" i18n="@@common.referral_payout">Referral Payout</div>
        <div class="с-pql-field-new__type с-pql-field-new">
          {{ item.modelValue }}
        </div>
        <div class="с-pql-field-new__name">
          <gtd-ui-field-special-pql-type-free-new [pql]="item.pql"></gtd-ui-field-special-pql-type-free-new>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
<ng-container *ngIf="!referralPayoutsView">
  <span class="text-color--light-gray">-</span>
</ng-container>
